<template>
  <el-container>
    <!--<el-main style="background: url(/static/img/login/yougo_bg2.jpg) no-repeat center center; background-size: 100% 100%;">-->
    <el-main style="background: url(/loginimg/bg_caiw.jpg) no-repeat center center; background-size: 100% 100%;">
      <table style="width:100%;height:100%;margin:auto">
        <tbody>
        <tr>
          <td>
            <img class="img_wanzhuan" :src="loginimg">
            <el-form :model="form" label-position="left" label-width="0px" class="loginarea" :rules="rules"
                     style="background-image: url(/static/img/login/textbg.png);"
                     ref="form1">
              <h3 class="logintitle" style="margin-bottom: 30px">
                <el-tabs style="float:left;width:220px">
                  <el-tab-pane label="密码登录" ></el-tab-pane>
                </el-tabs>
                <div style="float: right;font-size: x-small"><a href="/static/file/安全登录助手.zip" target="_blank">安全登录助手</a></div>
              </h3>
              <el-form-item prop="LoginName">
                <el-input prefix-icon="el-icon-mobile-phone" type="text" v-model="form.LoginName"
                          auto-complete="off"
                          placeholder="请输入手机号"
                          v-focus="{ cls: 'el-input',tag: 'input', foc: focususername }"
                          v-on:blur="focususername=false"></el-input>
              </el-form-item>
              <el-form-item prop="PassWord">
                <el-input prefix-icon="el-icon-edit-outline" type="password" v-model="form.PassWord"
                          auto-complete="off"
                          placeholder="请输入密码"
                          v-focus="{ cls: 'el-input',tag: 'input', foc: focuspassword }"
                          v-on:blur="focuspassword=false" ></el-input>
              </el-form-item>
              <el-checkbox class="login_remember" checked v-model="checked" label-position="left">记住账号
              </el-checkbox>
              <a class="Register BottomFont" @click="ShowRegister">修改密码</a>
              <el-form-item style="width:100%;">
                <el-button :type="XiaoTuan?'success':'primary'" style="width:80%;" @click.native.prevent="login"
                           :disabled="hasSubmit">登 录
                </el-button>
              </el-form-item>
            </el-form>
            <TenantList ref="TenantList" :datalist="tenantlist" @selectTenant="selectTenant"></TenantList>
            <RegisterPW ref="RegisterPW" @AfterRegister="AfterRegister"></RegisterPW>
            <RegisterPre ref="RegisterPre" @AfterRegister="AfterRegister"></RegisterPre>
          </td></tr></tbody></table>
    </el-main>
    <el-footer>Copyright © {{yearflag}} <a href="https://beian.miit.gov.cn/" target="_blank">{{ICP}}</a></el-footer>
  </el-container>
</template>
<script>
  import TenantList from './TenantList'
  import RegisterPW from './RegisterPW'
  import RegisterPre from './RegisterPre'
  import {login, setTenant, getTenantSet,sendVerificationCode,isXiaoTuan} from '../../api/login'

  export default {
    name: "login",
    data() {
      return {
        loginparam: [],
        XiaoTuan:false,
        hasSubmit: false,
        formLabelWidth: '120px',
        tenantlist: [],
        countName: '获取验证码',
        count: 60,
        timer: null,
        canpost: true,
        applist: [],//应用集合
        loginimg: '',
        beforelogintenantid: '',
        yearflag:2021,
        ICP:'',
        form: {
          LoginName: '',//18951936622
          PassWord: '',//88888
          smsiden: '',
        },
        checked: true,
        rules: {
          LoginName: [
            {required: true, message: '请输入手机号', trigger: 'change'},
          ],
          PassWord: [
            {required: true, message: '请输入密码', trigger: 'change'},
          ],
          smsiden: [
            {required: true, message: '请输入验证码', trigger: 'change'},
          ]
        },
        focususername: false,
        focuspassword: false,
        focussmsiden: false,
        machinecode: '',//机器码
      }
    },
    methods: {
      //获取本地机器码
      StartWebSocket() {
        var that = this
        var url = "ws://127.0.0.1:5000/";
        var ws = ''
        if ('WebSocket' in window) {
          ws = new WebSocket(url);
        } else if ('MozWebSocket' in window) {
          ws = new MozWebSocket(url);
        }
        ws.onopen = function () {
          // this.m_isConnectWS = true;
          console.log("Connection open ...");
          var msg = "{\"method\":\"getregistercode\"}";
          ws.send(msg);
        };
        ws.onerror = function () {
          console.log("Connection error ...");
        }
        ws.onmessage = function (e) {
          var data = e.data;
          that.machinecode = data
        }
        ws.onclose = function () {
          // this.m_isConnectWS = false;
          console.log("连接中断");
        };
      },
      login() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            if (this.hasSubmit)
              return;
            this.hasSubmit = true;

            //调用登录接口
            login({
              loginName: this.form.LoginName,
              password: this.form.PassWord,
              smsiden: "",
              LoginFrom: "pcback"
            }).then(response => {
              setTimeout(() => {
                this.hasSubmit = false;
              }, 2000);
              if (response.data.code == 0||(response.data.code == 1 && response.data.handletype == 'register')) {//全局登录成功
                //判断复选框是否被勾选 勾选则调用配置cookie方法
                if (this.checked) {
                  //传入账号名，密码，和保存天数3个参数
                  this.setCookie(this.form.LoginName,this.form.PassWord, 7);
                } else {
                  this.clearCookie();
                }

                localStorage.setItem("hpapi_token", response.data.token);
                // localStorage.setItem("hpapi_bi_token", response.data.token);

                var tokenInfo = response.data.obj;

                tokenInfo.attviewpath = this.loginparam.attviewpath
                localStorage.setItem("hpapi_tokenModel", JSON.stringify(tokenInfo));
                if (response.data.handletype == 'register') {//跳转到注册流程
                  this.$refs.RegisterPre.show(this.form.LoginName);
                  return;
                }

                if (tokenInfo.tenantDO.length == 1) {
                  var tenantDo = tokenInfo.tenantDO[0];
                  this.selectTenant(tenantDo);
                } else {//存在多个
                  this.tenantlist = tokenInfo.tenantDO;
                  this.$refs.TenantList.dialogFormVisible = true;
                }
              } else {
                //登录失败
                if (response.data.handletype) {
                  if (response.data.handletype == 'setpw') {//首次登录，请设置密码！
                    this.$refs.RegisterPW.show('首次登录，请设置密码！', this.form.LoginName, this.form.smsiden);
                  }
                }
                else {
                  this.focususername = true;
                  this.$message.error({message: response.data.msg});
                }
              }
            }).catch((error) => {
              this.focususername = true;
              console.log(error)
            });

          } else {
            this.focususername = true;
            //this.$message.error('请核对手机号、密码是否正确!!')
            return false;
          }
        });
      },
      AfterRegister(mobile, pw) {
        if (mobile && pw) {
          this.form.LoginName = mobile;
          this.form.PassWord = pw;
          this.checked = true;
        }
        this.hasSubmit = false;
        this.login();
      },
      ShowRegister() {
        this.$refs.RegisterPW.show('修改密码');
      },
      getCode() {
        if (this.form.LoginName == '')
          return;
        const TIME_COUNT = 60;
        if (!this.timer) {
          var self = this;
          self.count = TIME_COUNT;
          if (self.canpost) {
            sendVerificationCode({type: 'login', mobile: this.form.LoginName}).then(response => {
              this.$message({
                message: '验证码发送成功！',
                type: 'success'
              })
            });
          }
          self.canpost = false;
          self.timer = setInterval(() => {
            if (self.count > 0 && self.count <= TIME_COUNT) {
              self.count--;
              self.countName = '' + self.count + 's';
            } else {
              self.canpost = true;
              self.countName = '获取验证码';
              clearInterval(self.timer);
              self.timer = null;
            }
          }, 1000)
        }
      },
      selectTenant(row) {
        if (window.location.host.indexOf('localhost') > -1) {//本地调试用
          row.appurl = 'http://' + window.location.host + '/#/index'
          row.apiurl = ''
        }
        setTenant({
          appguid: row.appguid,
          tenantID: row.unitguid,
          machinecode: this.machinecode,//机器码
          rs: 1,
          uguid: row.uguid,
          apiurl: row.apiurl,
          isAppChanged: true,
        }).then(responseUser => {
          if (responseUser.data.code == 0) {
            localStorage.setItem("hpapi_userInfoModel", JSON.stringify(responseUser.data.obj));
            document.title = responseUser.data.obj.tenantname;// + "【" + row.appname + "】";
            localStorage.setItem("tenantid", row.unitguid);

            //跳转到指定路由
            var RoutePath = '';
            let tokenModel = JSON.parse(localStorage.getItem("hpapi_tokenModel"))
            var tenantModel = tokenModel.tenantDO;
            // for (var i = 0; i < tenantModel.length; i++) {
            //   if (tenantModel[i].unitguid == responseUser.data.obj.tenantid && tenantModel[i].uguid == responseUser.data.obj.uguid)
            //     RoutePath = tenantModel[i].mainurl;
            // }

            var hrefroute = '';
            if (RoutePath && RoutePath != '') {
              hrefroute = RoutePath;// this.$route.params.redirect
            } else {
              localStorage.setItem("appguid", row.appguid);
              hrefroute = row.appurl + "?appguid=" + row.appguid
                + "&token=" + localStorage.getItem("hpapi_token");
            }
            if (row.ifusemember == -1) {//跳转到初始化页面
              localStorage.setItem("hrefroute", hrefroute);
              this.$router.push("/Register");
            } else {
              window.location.href = hrefroute;
            }

          } else {//获取错误
            this.focususername = true;
            this.$message({
              message: responseUser.data.msg,
              type: 'error',
              duration: 15000,
            });
          }
        });
      },
      cancel() {
        localStorage.removeItem("hpapi_token");
        localStorage.removeItem("hpapi_tokenModel");
        localStorage.removeItem("hpapi_userInfoModel");
      },
      setCookie(c_name, c_pwd, exdays) {
        var exdate = new Date();//获取时间
        exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays);//保存的天数
        //字符串拼接cookie
        window.document.cookie = "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
        window.document.cookie = "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
      },
      //读取cookie
      getCookie: function () {
        this.form.LoginName = ''
        if (document.cookie.length > 0) {
          var arr = document.cookie.split('; ');//这里显示的格式需要切割一下自己可输出看下
          for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split('=');//再次切割
            //判断查找相对应的值
            if (arr2[0] == 'userName') {
              this.form.LoginName = arr2[1];//保存到保存数据的地方
            } else if (arr2[0] == 'userPwd') {
              this.form.PassWord = arr2[1];
            }
          }
        }
        if (!this.form.PassWord) {
          this.focuspassword = true;
         }
      },
      //清除cookie
      clearCookie: function () {
        this.setCookie("", "", -1);//修改2值都为空，天数为负1天就好了
      }
    },
    mounted() {
      this.XiaoTuan=isXiaoTuan();
      this.StartWebSocket();
      this.getCookie();
      var host = window.location.host;
      getTenantSet({"website": host}).then(reponse => {
        this.loginparam = reponse.data;
        this.loginimg = reponse.data.apiset.loginimg;
        document.title = reponse.data.tenantname;
        this.beforelogintenantid = reponse.data.tenantid;
      });
      this.yearflag = new Date().getFullYear();
      if (host.indexOf("eyes.wang") > -1) {
        this.ICP = "苏ICP备19004653号-1";
      } else if (host.indexOf("lxpj.net") > -1) {
        this.ICP = "浙ICP备2023035747号-1";
      } else if (host.indexOf("lxpj.wang") > -1) {
        this.ICP = "浙ICP备2023035747号-2";//老仙
      } else if (host.indexOf("yougoujingcang.com") > -1) {
        this.ICP = "辽ICP备2025054521号-1";//优购
      }else if (host.indexOf("xiaotuanglasses.com") > -1) {
        this.ICP = "苏ICP备2024119790号-1";//小团
      }else if (host.indexOf("dataoyanjing.com") > -1) {
        this.ICP = "津ICP备2026006320号-1";//大涛
      }else if (host.indexOf("mucunyanjing.com") > -1) {
        this.ICP = "津ICP备2026006320号-2";//大涛
      } else {
        this.ICP = " 苏ICP备16001801号-1";//zyanjing.com
      }
    },
    components: {
      TenantList,
      RegisterPW,
      RegisterPre
    }
  }
</script>

<style scoped>

.el-main {
  padding: 0px;
  width: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  height: 100%;
  line-height: 100%;
  position: fixed;
  text-align: center;
}

.el-input {
  width: 80%;
  font-size: 16px;
  color: #333333;
}

.el-form-item__error {
  padding-left: 40px !important;
}

.img_wanzhuan {
  margin-top: 5%;
}
.loginarea {
  float: right;
  margin-right: 16%;
  width: 380px;
  height: 380px;
  background-position: center center;
  background-repeat: no-repeat;
}

.logintitle {
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  padding-left: 20px;
  font-weight: bold;
  color: #333;
  letter-spacing: 5px;
  text-align: left;
}

.BottomFont {
  color: #409EFF;
  float: right;
  padding-right: 60px;
  font-size: 14px;
  cursor: pointer;
}

.el-footer {
  padding: 0px;
  background-color: #ffffff;
  height: 60px;
  font-size: 14px;
  color: #4f616e;
  text-align: center;
  line-height: 60px;
  position: fixed;
  bottom: 0px;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue